module.exports = __webpack_public_path__ + "static/media/ggplay.432876af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/ggplay.svg
// module id = 417
// module chunks = 37